import { RPDF } from './common/react-pdf';
import React from 'react';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';

export const ReportEmptyList: React.VoidFunctionComponent = () => {
  const i18next = useScopedTranslation('calendar.report');
  return (
    <RPDF.View style={RPDF.styles.emptyContainer}>
      <RPDF.View style={RPDF.styles.emptyTextContainer}>
        <RPDF.Text style={RPDF.styles.emptyTitle}>
          {i18next.t('empty_list_title')}
        </RPDF.Text>
        <RPDF.Text style={RPDF.styles.emptyText}>
          {i18next.t('empty_list_text')}
        </RPDF.Text>
      </RPDF.View>
    </RPDF.View>
  );
};
